import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref, inject, nextTick, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonTabs',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const criteria = inject<any>("criteria");
const fetchData = inject<any>("fetchData");
const tabsData = inject<any>("tabsData");

const activeTab = ref(0);
const isHandleClickTriggered = ref(false);

const handleClick = async () => {
  isHandleClickTriggered.value = true;
  await updateTab();
  isHandleClickTriggered.value = false;
};

const updateTab = async () => {
  await nextTick();
  criteria.value.status = tabsData[activeTab.value].status;
  await fetchData(1);
};

watch(
  () => criteria.value.status,
  (newVal) => {
    if (isHandleClickTriggered.value == false) {
      activeTab.value = tabsData.findIndex((tab) => tab.status === newVal);
      console.log(activeTab.value);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, {
    onTabClick: handleClick,
    modelValue: activeTab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabsData), (tab, index) => {
        return (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: index,
          label: tab.label,
          name: tab.index,
          disabled: _unref(isLoading)
        }, null, 8, ["label", "name", "disabled"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})